module.exports = __webpack_public_path__ + "img/zz.15aa090d.png";